/*
 * @Description:
 * @Date: 2022-04-12 19:51:20
 */
/*
 * @Description:
 * @Date: 2022-04-11 20:43:05
 */
import { defineComponent, getCurrentInstance, ref } from 'vue';
import { Button, Loading, ConfigProvider } from 'vant';
import { isFunction } from '@/utils/is';
export default defineComponent({
  name: 'xrk-button',
  setup() {
    const ctx = getCurrentInstance();
    const loading = ref(false);
    let _onClick = null;
    if (ctx.attrs.onClick) {
      const click = ctx.attrs.onClick;
      _onClick = async ({ ...params }: any) => {
        if (loading.value) return;
        loading.value = true;
        if (isFunction(click)) {
          try {
            await click(params);
          } catch (error) {
            console.warn(error);
            loading.value = false;
          }
        }
        loading.value = false;
      };
      delete ctx.attrs.onClick;
    }
    return {
      slotDefault: ctx.slots.default,
      _onClick: _onClick,
      attrs: ctx.attrs,
      loading
    };
  },
  render() {
    delete this.attrs.onClick;
    return (
      <ConfigProvider
        theme-vars={{
          buttonPrimaryBackgroundColor: '#F7E00B',
          buttonPrimaryBorderColor: '#F7E00B',
          buttonPrimaryColor: '#1F1F1F  '
        }}
        onClick={this._onClick}
      >
        <Button
          style={{
            borderRadius: '0.16rem',
            fontSize: '0.43rem',
            fontWeight: '500'
          }}
          {...{
            type: 'primary',
            ...this.attrs,
            disabled: this.attrs.disabled || this.loading,
            loadingText: this.attrs.loadingText
              ? `${this.attrs.loadingText}`
              : '提交中',
            loading: this.loading,
            onClick: null // 事件会被绑定在ConfigProvider上，所以给置空
          }}
        >
          {{
            loading: () => <Loading type="spinner" size="20" />,
            default: () => this.slotDefault?.()
          }}
        </Button>
      </ConfigProvider>
    );
  }
});
